// Display-only helpers to surface the lineage of conditional-aggregation
// calc measures (SUM_IF / COUNT_IF / MEDIAN_IF / PERCENTILE_IF / WEIGHTED_AVG …)
// on the catalog and lineage screens — the underlying column + the condition —
// so stewards can trust a measure at a glance. Best-effort top-level parse;
// mirrors backend/formula_engine.py but never executes anything.

const COND_AGG_LABEL = {
  SUM_IF: 'Sum', COUNT_IF: 'Count', COUNT_DISTINCT_IF: 'Distinct count',
  AVG_IF: 'Average', MIN_IF: 'Minimum', MAX_IF: 'Maximum',
  MEDIAN_IF: 'Median', PERCENTILE_IF: 'Percentile', WEIGHTED_AVG: 'Weighted average',
};
const COND_AGG_RE = /\b(SUM_IF|COUNT_DISTINCT_IF|COUNT_IF|AVG_IF|MIN_IF|MAX_IF|MEDIAN_IF|PERCENTILE_IF|WEIGHTED_AVG)\s*\(/i;

export function isConditionalFormula(formula) {
  return !!(formula && COND_AGG_RE.test(formula));
}

function matchBalanced(s, openIdx) {
  let depth = 0;
  for (let i = openIdx; i < s.length; i++) {
    if (s[i] === '(') depth++;
    else if (s[i] === ')') { depth--; if (depth === 0) return i; }
  }
  return -1;
}

function splitTopLevelCommas(s) {
  const parts = []; let depth = 0, cur = '';
  for (const ch of s) {
    if (ch === '(') { depth++; cur += ch; }
    else if (ch === ')') { depth--; cur += ch; }
    else if (ch === ',' && depth === 0) { parts.push(cur); cur = ''; }
    else cur += ch;
  }
  if (cur.trim()) parts.push(cur);
  return parts;
}

function cleanField(expr) {
  const e = (expr || '').trim();
  const m = e.match(/^\{([^{}]+)\}$/);
  return m ? m[1].trim() : e;
}

// Return [{ agg, label, field, percentile?, condition }] for every conditional
// aggregate found in the formula, or [] when there are none.
export function describeConditionalFormula(formula) {
  if (!isConditionalFormula(formula)) return [];
  const out = [];
  const re = new RegExp(COND_AGG_RE.source, 'gi');
  let m;
  while ((m = re.exec(formula)) !== null) {
    const fn = m[1].toUpperCase();
    const open = m.index + m[0].length - 1;
    const close = matchBalanced(formula, open);
    if (close < 0) break;
    const args = splitTopLevelCommas(formula.slice(open + 1, close));
    const item = { agg: fn, label: COND_AGG_LABEL[fn] || fn };
    if (fn === 'COUNT_IF') {
      item.field = 'rows';
      item.condition = (args[0] || '').trim();
    } else if (fn === 'PERCENTILE_IF') {
      item.field = cleanField(args[0]);
      item.percentile = (args[1] || '').trim();
      item.condition = (args[2] || '').trim();
    } else if (fn === 'WEIGHTED_AVG') {
      item.field = args.map(cleanField).join(' × ');
    } else {
      item.field = cleanField(args[0]);
      item.condition = (args[1] || '').trim();
    }
    out.push(item);
    re.lastIndex = close + 1;
  }
  return out;
}
